import {
    IPayment,
} from '../types/payment';

import {
    useState,
} from 'react';

import {
    createPaymentFetch,
} from '../fetches/create-payment.fetch';
import {
    ICreatePaymentDto,
} from '../requests/create-payment.dto';
import {
    ICreatePaymentResponse,
} from '../responses/create-payment.response';

export function usePayment() {
    const [payment, setPayment] = useState<IPayment | null>(null);

    const createPayment = async (dto: ICreatePaymentDto): Promise<ICreatePaymentResponse> => {
        const res = await createPaymentFetch(dto);

        if (!res.payment || res.error) {
            console.log(res.error);

            return res;
        }

        setPayment(res.payment);

        return res;
    };

    return {
        payment,
        createPayment,
    };
}
